<app-message
    [successMessage]="true"
    [messageTitle]="'messages.identification-success.title' | translate"
    [message]="'messages.identification-success.description' | translate:{'altEmail':altEmail}"
>
</app-message>
